import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/AdComponent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/AvatarLocation/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/NewsSection/NewsWithLoadMore.tsx");
;
import(/* webpackMode: "eager" */ "/home/app/workspace/node_modules/next/dist/client/app-dir/link.js");
